import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material';
import { useState } from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import BookDetailsMenu from './BookDetails/BookDetailsMenu';
import { useTranslation } from 'react-i18next';
import AboutBookDialog from './AboutBook/Dialog';
import { useDocumentContext } from './DocumentContext';
import AccountDialog from './Account/Dialog';

export default function NavigationMenu() {
  const [openAboutBook, setOpenAboutBook] = useState(false);
  const [openAccount, setOpenAccount] = useState(false);
  const { productMeta } = useDocumentContext();
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ paddingX: 2, paddingY: 3 }}>
        <BookDetailsMenu />
      </Box>
      <Divider />
      <MenuList sx={{ paddingY: 0 }}>
        <MenuItem divider onClick={() => setOpenAboutBook(true)}>
          {t('readingView.menu.navigation.aboutBook.cta')}
        </MenuItem>
        <MenuItem divider disabled>
          {t('readingView.menu.navigation.goToPage.cta')}
        </MenuItem>
        <MenuItem divider disabled>
          {t('readingView.menu.navigation.continueFromLastPage.cta')}
        </MenuItem>
        <MenuItem divider onClick={() => setOpenAccount(true)}>
          <ListItemIcon>
            <AccountCircleOutlinedIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText>{t('readingView.account.title')}</ListItemText>
        </MenuItem>
      </MenuList>
      <AboutBookDialog
        open={openAboutBook}
        onClose={() => setOpenAboutBook(false)}
        productMeta={productMeta}
      />
      <AccountDialog open={openAccount} onClose={() => setOpenAccount(false)} />
    </>
  );
}
